<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Barang Hilang</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="12">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterTanggalMulai" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterTanggalAkhir" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="12">
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                id="filterNoFaktur"
                                type="search"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <multiselect
                                name="dariCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="Cabang"
                            />
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Cari 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-button variant="success" @click="downloadExcel">Download Excel</b-button>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="daftarBarangHilang" 
                :fields="fields" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data gadai.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{ row.item.noFaktur }}</div>
                    <div class="smallText text-muted">{{ row.item.cabang }}</div>
                </template>
                <template v-slot:cell(pinjaman)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0" v-if="row.item.pinjaman !== null">Rp. {{$helper.addThousandSeparator(row.item.pinjaman)}} </p>
                        <p class="mb-0" v-else>{{$helper.addThousandSeparator(row.item.pinjaman)}} </p>                 
                    </div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </div>
                    <div v-else>
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </div>
                </template>
                <template v-slot:cell(diajukanPada)="row">
                    <div>{{$helper.changeDateFormat(row.item.diajukanPada)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.diajukanPada)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING EKSEKUTOR 1'">PENDING EKSEKUTOR 1</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'PENDING EKSEKUTOR 2'">PENDING EKSEKUTOR 2</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'DITOLAK EKSEKUTOR 1'">DITOLAK EKSEKUTOR 1</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'DITOLAK EKSEKUTOR 2'">DITOLAK EKSEKUTOR 2</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status == 'HILANG LELANG'">HILANG LELANG</b-badge>
                    <b-badge variant="dark" v-else>BATAL</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="gadaiViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="m-download" title="Download Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="statusDownload == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="statusDownload == -1">
                Gagal menyiapkan laporan.
            </div>
            <div v-else>
                Laporan sudah siap. Tekan tombol dibawah ini untuk download laporan Excel.
                <div class="mt-2">
                    <a :href="$baseFilePath + '/' + linkDownload" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'approval-barang-hilang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterTanggalMulai: null,
                filterTanggalAkhir: null,
                filterNoFaktur: null,
                filterStatus: null,
                filterCabang: null,
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur"},
                { key: "Barang", label: "Barang" },
                { key: "pinjaman", label: "Nilai Pinjaman"},
                { key: "diajukanOleh", label: "Diajukan Oleh"},
                { key: "diajukanPada", label: "Diajukan Pada"},
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [ 
                { id: null, name: 'Semua' },
                { id: 1, name: 'Pending Eksekutor 1' },
                { id: 2, name: 'Pending Eksekutor 2' },
                { id: 3, name: 'Ditolak Eksekutor 1' },
                { id: 4, name: 'Ditolak Eksekutor 2' },
                { id: 5, name: 'Diterima' },
                { id: 6, name: 'Hilang Lelang' },
                { id: 7, name: 'Batal' },
            ],
            daftarBarangHilang: [],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: "",

            statusDownload: 0, // 0 -> Loading, 1: OK, -1: Error
            linkDownload: ""

        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangId = this.$helper.getCabangId()
            this.query = this.query + "&cabangId=" + this.cabangId
            this.getDefaultStatus()
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            
            let getDaftarBarangHilang = this.$axios.get("gadai-hilang/daftar-hilang-eksekutor/"+this.query).then(response => {
                this.daftarBarangHilang = response.data.data
                this.updateTotalItem(response.data.total)
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            Promise.all([getDaftarBarangHilang, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarBarangHilang(){
            this.toggleBusy()
            this.daftarBarangHilang = []
            this.cabangId = this.$helper.getCabangId()

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) this.query = this.query + "&filterStartDate=" + this.input.filterTanggalMulai
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir)) this.query = this.query + "&filterEndDate=" + this.input.filterTanggalAkhir
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
           
            this.query += "&cabangId="+this.cabangId
            
            this.$axios.get("gadai-hilang/daftar-hilang-eksekutor/"+this.query).then(response => {
                this.daftarBarangHilang = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDaftarBarangHilang()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarBarangHilang()
            }
        },

        onReset(){
            this.input.filterTanggalMulai = null
            this.input.filterTanggalAkhir = null
            this.input.filterNoFaktur = null
            this.input.filterStatus = null
            localStorage.setItem('filterStatusBarangHilang', this.input.filterStatus)
            this.input.filterCabang = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDaftarBarangHilang()
        },

        onFilter() {
            localStorage.setItem('filterStatusBarangHilang', this.input.filterStatus)
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && !this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalAkhir) && this.$helper.isNotNullAndNotEmpty(this.input.filterTanggalMulai)) && (Date.parse(this.input.filterTanggalAkhir) < Date.parse(this.input.filterTanggalMulai))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getDaftarBarangHilang()
            }
        },

        downloadExcel() {

            if(this.input.filterTanggalMulai == null || this.input.filterTanggalAkhir == null) {
                return this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter sebelum mendownload excel!")
            }

            let param = "?startDate=" + this.input.filterTanggalMulai + "&endDate=" + this.input.filterTanggalAkhir

            this.statusDownload = 0
            this.$bvModal.show("m-download")
            this.$axios.get("gadai-hilang/download-excel" + param).then(res => {

                let data = res.data
                if(data.name == null) {
                    this.statusDownload = -1
                    return this.$helper.toastErr(this, "Gagal generate excel, silahkan coba kembali, atau hubungi IT!")
                }

                this.linkDownload = data.name
                this.statusDownload = 1

            })
            .catch(err => {
                this.statusDownload = -1
                this.$helper.parseError(this, err)
            })

        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },
        getDefaultStatus() {
            const saved = localStorage.getItem('filterStatusBarangHilang')
            if (saved != 'null' && saved != null) {
                this.input.filterStatus = saved
            }
        }
    },

    created(){
        this.init()
    }
}
</script>
